import { render, staticRenderFns } from "./FilesListV2.vue?vue&type=template&id=751ac776"
import script from "./FilesListV2.vue?vue&type=script&lang=js"
export * from "./FilesListV2.vue?vue&type=script&lang=js"
import style0 from "./FilesListV2.vue?vue&type=style&index=0&id=751ac776&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('751ac776')) {
      api.createRecord('751ac776', component.options)
    } else {
      api.reload('751ac776', component.options)
    }
    module.hot.accept("./FilesListV2.vue?vue&type=template&id=751ac776", function () {
      api.rerender('751ac776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FilesListV2.vue"
export default component.exports